import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/pregunta/importer/preguntaImporterActions';

export default importerReducers(actions);
